module.exports = __webpack_public_path__ + "static/media/UniNeueBlack-Italic.d8c789a0.woff";